/* tslint:disable */
/* eslint-disable */
/**
 * OSB Workspaces manager API
 * Opensource Brain Platform - Reference Workspaces manager API
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResourceOrigin,
    ResourceOriginFromJSON,
    ResourceOriginFromJSONTyped,
    ResourceOriginToJSON,
    ResourceStatus,
    ResourceStatusFromJSON,
    ResourceStatusFromJSONTyped,
    ResourceStatusToJSON,
    ResourceType,
    ResourceTypeFromJSON,
    ResourceTypeFromJSONTyped,
    ResourceTypeToJSON,
    WorkspaceResourceAllOf,
    WorkspaceResourceAllOfFromJSON,
    WorkspaceResourceAllOfFromJSONTyped,
    WorkspaceResourceAllOfToJSON,
    WorkspaceResourceBase,
    WorkspaceResourceBaseFromJSON,
    WorkspaceResourceBaseFromJSONTyped,
    WorkspaceResourceBaseToJSON,
} from './';

/**
 * Workspace Resource item of a Workspace
 * @export
 * @interface WorkspaceResource
 */
export interface WorkspaceResource {
    /**
     * 
     * @type {number}
     * @memberof WorkspaceResource
     */
    id?: number;
    /**
     * WorkspaceResource name
     * @type {string}
     * @memberof WorkspaceResource
     */
    name: string;
    /**
     * 
     * @type {ResourceStatus}
     * @memberof WorkspaceResource
     */
    status?: ResourceStatus;
    /**
     * Date/time of creation of the WorkspaceResource
     * @type {Date}
     * @memberof WorkspaceResource
     */
    timestampCreated?: Date;
    /**
     * Date/time of last updating of the WorkspaceResource
     * @type {Date}
     * @memberof WorkspaceResource
     */
    timestampUpdated?: Date;
    /**
     * Date/time of last opening of the WorkspaceResource
     * @type {Date}
     * @memberof WorkspaceResource
     */
    timestampLastOpened?: Date;
    /**
     * 
     * @type {ResourceType}
     * @memberof WorkspaceResource
     */
    resourceType: ResourceType;
    /**
     * workspace_id
     * @type {number}
     * @memberof WorkspaceResource
     */
    workspaceId?: number;
    /**
     * 
     * @type {ResourceOrigin}
     * @memberof WorkspaceResource
     */
    origin?: ResourceOrigin;
    /**
     * WorkspaceResource path where the resource will stored in the pvc.
     * @type {string}
     * @memberof WorkspaceResource
     */
    path?: string;
}

export function WorkspaceResourceFromJSON(json: any): WorkspaceResource {
    return WorkspaceResourceFromJSONTyped(json, false);
}

export function WorkspaceResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'status': !exists(json, 'status') ? undefined : ResourceStatusFromJSON(json['status']),
        'timestampCreated': !exists(json, 'timestamp_created') ? undefined : (new Date(json['timestamp_created'])),
        'timestampUpdated': !exists(json, 'timestamp_updated') ? undefined : (new Date(json['timestamp_updated'])),
        'timestampLastOpened': !exists(json, 'timestamp_last_opened') ? undefined : (new Date(json['timestamp_last_opened'])),
        'resourceType': ResourceTypeFromJSON(json['resource_type']),
        'workspaceId': !exists(json, 'workspace_id') ? undefined : json['workspace_id'],
        'origin': !exists(json, 'origin') ? undefined : ResourceOriginFromJSON(json['origin']),
        'path': !exists(json, 'path') ? undefined : json['path'],
    };
}

export function WorkspaceResourceToJSON(value?: WorkspaceResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'status': ResourceStatusToJSON(value.status),
        'timestamp_created': value.timestampCreated === undefined ? undefined : (value.timestampCreated.toISOString()),
        'timestamp_updated': value.timestampUpdated === undefined ? undefined : (value.timestampUpdated.toISOString()),
        'timestamp_last_opened': value.timestampLastOpened === undefined ? undefined : (value.timestampLastOpened.toISOString()),
        'resource_type': ResourceTypeToJSON(value.resourceType),
        'workspace_id': value.workspaceId,
        'origin': ResourceOriginToJSON(value.origin),
        'path': value.path,
    };
}


